import React from 'react';
import FontsDefault from '../../Assistant/DefaultStyle';

function CardAboutSteps({ title, img }) {
  return (
    <div className=''>
      <div className='flex justify-center mt-4'>
        <img src={img} alt='img' className='w-40 h-40' />
      </div>
      <div>
        <h1 className={`${FontsDefault.text2xl} font-bold mt-4 text-gray700`}>{title}</h1>
      </div>
    </div>
  );
}

export default CardAboutSteps;
